<template>
    <div>
        <v-card flat color="transparent" class="mt-7">
            <v-toolbar class="bdr secondary2light" :elevation="0" outlined >
                <v-toolbar-title>{{$t('animal.details')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-btn
                    icon
                    large
                    disabled
                >
                <v-icon>mdi-cog-outline</v-icon>
                </v-btn> -->
            </v-toolbar>
        </v-card>
        <v-card flat class="mt-7">
            <v-card-text>
                <v-tabs class="tabs-pill" v-model="tab">
                    <v-tab>{{$t('animal.familyInfo')}}</v-tab>
                    <v-tab>{{$t('animal.breedInfo')}}</v-tab>
                    <v-tab>{{$t('animal.identification')}}</v-tab>
                    <v-tab>{{$t('animal.animalOrigin')}}</v-tab>
                    <v-tab>{{$t('animal.removalInfo')}}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab" class="mt-5">
                    <v-tab-item> <general-family :animal="animal"/> </v-tab-item>
                    <v-tab-item> <general-breed/> </v-tab-item>
                    <v-tab-item> <general-identification/> </v-tab-item>
                    <v-tab-item> <general-animal-origin/> </v-tab-item>
                    <v-tab-item> <general-removal-info/> </v-tab-item>
                </v-tabs-items>
            </v-card-text>
    </v-card>
</div>
</template>
<script>
import AnimalService from "@/_services/AnimalService"

import GeneralFamily from "./general/GeneralFamily.vue"
import GeneralBreed from "./general/GeneralBreed.vue"
import GeneralIdentification from "./general/GeneralIdentification.vue"
import GeneralAnimalOrigin from "./general/GeneralAnimalOrigin.vue"
import GeneralRemovalInfo from "./general/GeneralRemovalInfo.vue"
export default {
    components: {
        GeneralFamily,
        GeneralBreed,
        GeneralIdentification,
        GeneralAnimalOrigin,
        GeneralRemovalInfo
    },
    created() {
        const fetchData = async () => {
            this.getSingleAnimalData(this.$route.params.animal_number, this.$route.params.source)
        }
        fetchData();
        
    },
    data() {
        return {
            animal: {},
            tab: null,
        }
    },

    methods: {
        getSingleAnimalData(animalId, source) {
            AnimalService.getSingleAnimal(animalId, source)
            .then( res => {
                this.animal =res.data.animalDetails;
            })
            .catch(err => {
                console.log(err)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
</style>